// eslint-disable-next-line
import {} from "rxjs";
// 引入combineEpics方法
import { combineEpics } from "redux-observable";
// eslint-disable-next-line

export default combineEpics();
